import { format, isValid, parse } from 'date-fns';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const DateField = ({
  input,
  disabled,
  label,
  labelRequired,
  placeholder,
  meta: { touched, error, submitError, warning },
  helpText,
  cssClass,
}) => {
  const { name, value, onChange, onBlur } = input;

  const handleChange = (date) => {
    if (date) {
      onChange(format(date, 'yyyy-MM-dd'));
    } else {
      onChange('');
    }
    onBlur();
  };

  const handleChangeRaw = (rawValue) => {
    if (rawValue === '') {
      onChange('');
    } else {
      onChange('invalid-date');
    }
    onBlur();
  };

  const selectedDate = () => {
    if (!value || value === 'invalid-date') return null;
    const parsed = parse(value, 'yyyy-MM-dd', new Date());
    return isValid(parsed) ? parsed : null;
  };

  if (!error) {
    error = submitError;
  }

  return (
    <div className={`form-group date${cssClass ? ' ' + cssClass : ''}${touched && error ? ' error' : ''}`}>
      {label && (
        <label htmlFor={name} className="w-100 mw-100">
          {label}
          {labelRequired && <abbr title="Required">*</abbr>}
        </label>
      )}
      <DatePicker
        selected={selectedDate()}
        onChange={handleChange}
        onChangeRaw={(event) => handleChangeRaw(event.target.value)}
        placeholderText={placeholder}
        dateFormat="dd/MM/yyyy"
        className="form-control"
        disabled={disabled}
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
      />
      {helpText && <div className="text-info">{helpText}</div>}
      {touched && error && <div className="text-danger">{error}</div>}
      {touched && warning && !error && <div className="text-warning">{warning}</div>}
    </div>
  );
};

DateField.propTypes = {
  input: PropTypes.object.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  meta: PropTypes.object,
  helpText: PropTypes.string,
  cssClass: PropTypes.string,
};

export default DateField;
